<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" fieldReadonly/>

    <!-- 목표 및 실적 -->
    <write-grid-container title="목표 및 실적" v-model="form.subInfo" :options="gridContainerOptions" class="sub mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input">{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <vs-select v-if="dataType === 'selector'" class="w-full" autocomplete v-model="form.subInfo[value]" >
            <vs-select-item v-for="item in ['목표', '실적']" :text="item" :value="item"/>
          </vs-select>
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" visible-counter type="number"
                    :defaultValue="header.year + 1" :min-value="1900" :max-value="2100" />
        </div>
      </template>
    </write-grid-container>
    <div>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div class="flex items-center">
            목표
            <div v-if="!isPrint" class="ml-auto block md:hidden">
              <vs-button color="secondary" type="border" @click="showListPopup = true">전사 목표</vs-button>
            </div>
          </div>
          <p v-if="isPrint" class="print-input">{{ form.subInfo.목표 }}</p>
          <div v-else class="grid md:flex gap-4">
            <div class="flex-1">
              <quill-editor class="quill-editor" v-model="form.subInfo.목표" :options="quillOption"></quill-editor>
            </div>
            <div class="ml-auto hidden md:block">
              <vs-button color="secondary" type="border" @click="showListPopup = true">전사 목표</vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <PopupLoadPrevBoard title="전사목표" :setBoardId="961" v-model="showListPopup" @selectRowData="loadGoalData" />
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";

export default {
  components: {
    PopupLoadPrevBoard,
    DateSelector,
    WriteGridContainer,
    FieldSelectModule,
    FileUploadModule,
    quillEditor
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id;
    },
    postId () {
      return this.$route.params.post_id;
    }
  },
  data() {
    return {
      quillOption: {
        placeholder: '내용을 입력해주세요'
      },
      showListPopup : false,
      form: {
        stdInfo: {},
        subInfo: {},
        photoList: [],
        fileList: [],
      },
      gridContainerOptions: {
        dataTypes: ["year"],
        labels: ["대상년도"],
        values: ["대상년도"],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  async created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }

    // 사업장명을 인천공장으로 설정
    const checkFieldName = '인천공장'
    if (!this.postId) {
      const fieldListInfo = await this.loadFieldList();
      if (fieldListInfo && fieldListInfo.data && fieldListInfo.data.length > 0) {
        const field = fieldListInfo.data.filter(item => item.field_name === checkFieldName)
        if (field && field.length > 0) {
          const fieldId = field[0].id
          const fieldName = field[0].field_name
          this.form.stdInfo.field_id = fieldId
          this.form.stdInfo.field_name = fieldName
        }
      }
    }
  },
  methods: {
    async loadFieldList() {
      const projectId = this.projectId;
      const page = 1;
      const perPage = 10;

      return await this.$store.dispatch("project/LOAD_FIELD_LIST", { projectId, page, perPage, showAll: 1 });
    },
    loadGoalData(data) {
      if (data && data.post_content) {
        const content = JSON.parse(data.post_content)
        const body = content.body

        this.form.subInfo.목표 = body.subInfo.목표
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* 에디터의 행 수 설정 */
.quill-editor::v-deep {
  .ql-editor {
    min-height: calc(12px * 2 + 1.42rem * 20); /* 20행 기준 */
  }
}
</style>
